export enum ContainerColor {
  TRANSPARENT = 'transparent',
  THEME_AWARE = 'theme-aware',
  NEUTRAL_GRADIENT_TOP_LEFT = 'neutral-gradient-top-left',
  NEUTRAL_GRADIENT_BOTTOM_RIGHT = 'neutral-gradient-bottom-right',
  NEUTRAL_GRADIENT_NEUTRAL_100_NEUTRAL_400 = 'neutral-gradient-neutral-100-neutral-400',
  NEUTRAL_100 = 'neutral-100',
  NEUTRAL_200 = 'neutral-200',
  GREY_50 = 'grey-50',
  GREY_100 = 'grey-100',
  GREY_300 = 'grey-300',
  WHITE = 'white',
  AWARE_SOFT_TOP_LEFT = 'aware-gradient-top-left',
  AWARE_SOFT_BOTTOM_RIGHT = 'aware-gradient-bottom-right',
  BLUE_GRADIENT_TOP_LEFT = 'blue-gradient-top-left',
  BLUE_GRADIENT_BOTTOM_RIGHT = 'blue-gradient-bottom-right',
  SPLIT_GRADIENT = 'split-gradient-radial',
  GRADIENT_WHITE_TO_GRAY_4 = 'split-gradient-linear',
  BRAND_GRADIENT = 'brand-gradient',
}
